import React from 'react';
import { useTranslation } from 'react-i18next';
import { func, bool } from 'prop-types';
import { Menu } from 'antd';

const RecordingsMenu = ({ scheduleNpvrRecording, isNpvrActive }) => {
	const { t } = useTranslation();

	return (
		<Menu>
			{isNpvrActive && (
				<Menu.Item onClick={scheduleNpvrRecording}>
					{t(`recording_dropdown_npvr`)}
				</Menu.Item>
			)}
		</Menu>
	);
};

RecordingsMenu.PropsTypes = {
	scheduleNpvrRecording: func.isRequired,
	isNpvrActive: bool
};

export default RecordingsMenu;
